import React from "react";

const styleTd = {padding: 8};

export const Table = ({fieldNames, children}) => (
    <table style={{width: "100%"}} className="w3-table-all w3-table">
        <thead>
        <tr className="vl-theme">
            {fieldNames.map(e => (
                <th key={e} style={styleTd}>{e}</th>
            ))}
        </tr>
        </thead>
        <tbody>
        {children}
        </tbody>
    </table>
);

export default Table;